<template>
  <div>
    <!-- phones get a two-column table that sorts, the rest of each player under a tap; desktop keeps the full table -->
    <PlayerTable
      class="md:hidden"
      kind="goals"
      :match="match"
      :homeList="homeList"
      :awayList="awayList"
      :sortValue="sortValue"
      :homeInjured="homeInjured"
      :homeSuspended="homeSuspended"
      :awayInjured="awayInjured"
      :awaySuspended="awaySuspended"
      :playerProps="playerProps"
      :slipMatch="slipMatch"
      :lineupConfirmed="lineupConfirmed"
    />
    <div class="player-tables hidden md:block">
    <!-- Home Table -->
    <div
      class="mt-3 border-gray-100 border-[1px]"
      v-if="homeList && homeList.length > 0"
      :class="{ 'only-5-toggle': goalScorersHomeShort }"
    >
      <div
        class="flex p-2 bg-[#ffd5d5] border-b-[1px] border-gray-400 rounded-t-lg font-semibold text-xs select-none"
      >
        <h3
          class="w-36 flex-none min-w-0 pr-2 uppercase text-sm text-black text-shadow-sm flex items-center"
        >
          <img :src="match.home_team.logo" class="cursor-pointer w-4 h-auto mr-1" @click.stop="openTeam(match.home_team)" title="Team page" />
          {{ match.home_team.name }}
        </h3>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('appearances')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Appearances">Apps</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Appearances</li>
            </ul>
            <span v-if="homeSort.key === 'appearances'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('goals_all_comps')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Goals">Goals</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Total Goals This Season</li>
            </ul>
            <span v-if="homeSort.key === 'goals_all_comps'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('goal_prediction')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Percentage to Score">To score</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>AI Chance of Scoring</li>
            </ul>
            <span v-if="homeSort.key === 'goal_prediction'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <!-- <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('assists')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Assists">Ast</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Total Assists This Season</li>
            </ul>
            <span v-if="homeSort.key === 'assists'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div> -->
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('avg_shots_total')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Avg Total Shots">Shots/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Shots Per 90</li>
            </ul>
            <span v-if="homeSort.key === 'avg_shots_total'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('avg_shots_on_target')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Avg Shots on Target">SOT/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Shots on Target Per 90</li>
            </ul>
            <span v-if="homeSort.key === 'avg_shots_on_target'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('avg_xg')"
        >
          <span class="inline-block leading-tight px-0.5" title="Expected goals per game">xG/g</span>
          <span v-if="homeSort.key === 'avg_xg'" class="ml-1">{{
            homeSort.asc ? "▲" : "▼"
          }}</span>
        </div>
        <div
          v-if="hasHomeProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ shot on target"
          @click="!propsLocked && sortHome('prop|sot|1+')"
        >
          SOT 1+<span v-if="homeSort.key === 'prop|sot|1+'" class="ml-1">{{ homeSort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasHomeProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 2+ shots"
          @click="!propsLocked && sortHome('prop|shots|2+')"
        >
          Shots 2+<span v-if="homeSort.key === 'prop|shots|2+'" class="ml-1">{{ homeSort.asc ? "▲" : "▼" }}</span>
        </div>
      </div>
      <div
        class="text-xxs only-5-item p-2"
        v-for="(item, key) in sortedHome.slice(0, homeVisible)"
        :key="key"
        :class="key % 2 === 0 ? 'bg-[#FAEBEA]' : 'bg-[#ffd5d5]'"
      >
        <p class="flex">
          <span
            class="w-36 flex-none min-w-0 pr-2 leading-tight"
            :class="isOut(item.name, homeInjured, homeSuspended) ? 'text-red-500' : 'text-gray-700'"
            >{{ item.name }}
            <img
              v-if="homeInjured.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/red-cross.png"
              title="Injured"
            />
            <img
              v-if="homeSuspended.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/yellowred.png"
              title="Suspended"
            />
          </span>
          <span class="flex-1 text-center">{{ item.appearances }}</span>
          <span class="flex-1 text-center">{{ item.goals_all_comps }}</span>
          <PropCell
            v-if="hasHomeProps"
            :playerProps="playerProps" side="home_team" :item="item"
            market="goal" :slipMatch="slipMatch"
          />
          <span v-else class="flex-1 text-center">{{
            item.goal_prediction || "-"
          }}</span>
          <!-- <span class="flex-1 text-center">{{ item.assists }}</span> -->
          <span class="flex-1 text-center">{{
            Math.round(item.avg_shots_total * 10) / 10
          }}</span>
          <span class="flex-1 text-center">{{
            Math.round(item.avg_shots_on_target * 10) / 10
          }}</span>
          <span class="flex-1 text-center">{{
            item.avg_xg === undefined || item.avg_xg === null ? "-" : Number(item.avg_xg).toFixed(2)
          }}</span>
          <template v-if="hasHomeProps">
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="sot" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="shots" line="2+" :slipMatch="slipMatch" />
          </template>
        </p>
      </div>
      <div
        class="flex items-center justify-center py-2 border-t-[1px] border-gray-400 rounded-b-lg bg-[#ffd4d4]"
        v-if="sortedHome.length > 5"
      >
        <button
          class="text-gray-500 uppercase underline text-xxs"
          @click="toggleShowMore('home')"
        >
          <template v-if="homeVisible < sortedHome.length">Show more</template>
          <template v-else>Show less</template>
        </button>
      </div>
    </div>
    <div v-else class="flex items-start align-top space-x-4">
      <span class="w-full align-bottom py-2 text-center text-gray-500 text-xs">
        No recent home team goal scorers
      </span>
    </div>
    <!-- Away Table -->
    <div
      class="my-3 border-gray-100 border-[1px]"
      v-if="awayList && awayList.length > 0"
      :class="{ 'only-5-toggle': goalScorersAwayShort }"
    >
      <div
        class="flex p-2 bg-[#dcdcff] border-b-[1px] border-gray-400 rounded-t-lg font-semibold text-xs select-none"
      >
        <h3
          class="w-36 flex-none min-w-0 pr-2 uppercase text-sm text-black text-shadow-sm flex items-center"
        >
          <img :src="match.away_team.logo" class="cursor-pointer w-4 h-auto mr-1" @click.stop="openTeam(match.away_team)" title="Team page" />
          {{ match.away_team.name }}
        </h3>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('appearances')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Appearances">Apps</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Appearances</li>
            </ul>
            <span v-if="awaySort.key === 'appearances'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('goals_all_comps')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Goals">Goals</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Total Goals This Season</li>
            </ul>
            <span v-if="awaySort.key === 'goals_all_comps'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('goal_prediction')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Percentage to Score">To score</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>AI Chance of Scoring</li>
            </ul>
            <span v-if="awaySort.key === 'goal_prediction'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <!-- <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('assists')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Assists">Ast</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Total Assists This Season</li>
            </ul>
            <span v-if="awaySort.key === 'assists'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div> -->
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('avg_shots_total')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Avg Total Shots">Shots/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Shots Per 90</li>
            </ul>
            <span v-if="awaySort.key === 'avg_shots_total'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('avg_shots_on_target')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Avg Shots on Target">SOT/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Shots on Target Per 90</li>
            </ul>
            <span v-if="awaySort.key === 'avg_shots_on_target'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('avg_xg')"
        >
          <span class="inline-block leading-tight px-0.5" title="Expected goals per game">xG/g</span>
          <span v-if="awaySort.key === 'avg_xg'" class="ml-1">{{
            awaySort.asc ? "▲" : "▼"
          }}</span>
        </div>
        <div
          v-if="hasAwayProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ shot on target"
          @click="!propsLocked && sortAway('prop|sot|1+')"
        >
          SOT 1+<span v-if="awaySort.key === 'prop|sot|1+'" class="ml-1">{{ awaySort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasAwayProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 2+ shots"
          @click="!propsLocked && sortAway('prop|shots|2+')"
        >
          Shots 2+<span v-if="awaySort.key === 'prop|shots|2+'" class="ml-1">{{ awaySort.asc ? "▲" : "▼" }}</span>
        </div>
      </div>
      <div
        class="text-xxs only-5-item p-2"
        v-for="(item, key) in sortedAway.slice(0, awayVisible)"
        :key="key"
        :class="key % 2 === 0 ? 'bg-[#F5F5FE]' : 'bg-[#dcdcff]'"
      >
        <p class="flex">
          <span
            class="w-36 flex-none min-w-0 pr-2 leading-tight"
            :class="isOut(item.name, awayInjured, awaySuspended) ? 'text-red-500' : 'text-gray-700'"
            >{{ item.name }}
            <img
              v-if="awayInjured.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/red-cross.png"
              title="Injured"
            />
            <img
              v-if="awaySuspended.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/yellowred.png"
              title="Suspended"
            />
          </span>
          <span class="flex-1 text-center">{{ item.appearances }}</span>
          <span class="flex-1 text-center">{{ item.goals_all_comps }}</span>
          <PropCell
            v-if="hasAwayProps"
            :playerProps="playerProps" side="away_team" :item="item"
            market="goal" :slipMatch="slipMatch"
          />
          <span v-else class="flex-1 text-center">{{
            item.goal_prediction || "-"
          }}</span>
          <!-- <span class="flex-1 text-center">{{ item.assists }}</span> -->
          <span class="flex-1 text-center">{{
            Math.round(item.avg_shots_total * 10) / 10
          }}</span>
          <span class="flex-1 text-center">{{
            Math.round(item.avg_shots_on_target * 10) / 10
          }}</span>
          <span class="flex-1 text-center">{{
            item.avg_xg === undefined || item.avg_xg === null ? "-" : Number(item.avg_xg).toFixed(2)
          }}</span>
          <template v-if="hasAwayProps">
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="sot" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="shots" line="2+" :slipMatch="slipMatch" />
          </template>
        </p>
      </div>
      <div
        class="flex items-center justify-center py-2 border-t-[1px] border-gray-400 rounded-b-lg bg-[#d1d1ff]"
        v-if="sortedAway.length > 5"
      >
        <button
          class="text-gray-500 uppercase underline text-xxs"
          @click="toggleShowMore('away')"
        >
          <template v-if="awayVisible < sortedAway.length">Show more</template>
          <template v-else>Show less</template>
        </button>
      </div>
    </div>
    <div v-else class="flex items-start align-top space-x-4">
      <span class="w-full align-bottom py-2 text-center text-gray-500 text-xs">
        No recent away team goal scorers
      </span>
    </div>
    </div>
  </div>
</template>

<script>
import PropCell from "./betslip/PropCell.vue";
import PlayerTable from "./betslip/PlayerTable.vue";
import { propP, propsLocked } from "./betslip/propValue";

import teamLinks from "@/teamLinks";
export default {
  mixins: [teamLinks],
  components: { PropCell, PlayerTable },
  name: "GoalsShotsTable",
  props: {
    homeList: { type: Array, required: true },
    awayList: { type: Array, required: true },
    homeInjured: { type: Array, default: () => [] },
    homeSuspended: { type: Array, default: () => [] },
    awayInjured: { type: Array, default: () => [] },
    awaySuspended: { type: Array, default: () => [] },
    match: { type: Object, required: true },
    // bet slip: the match-info `props` block and {match_id, title, kickoff}
    playerProps: { type: Object, default: null },
    slipMatch: { type: Object, default: null },
    lineupConfirmed: { type: Boolean, default: false },
    homeShort: { type: Boolean, default: true },
    awayShort: { type: Boolean, default: true },
  },
  data() {
    return {
      homeSort: { key: "goals_all_comps", asc: false },
      awaySort: { key: "goals_all_comps", asc: false },
      homeVisible: 5,
      awayVisible: 5,
    };
  },
  computed: {
    hasHomeProps() {
      return !!(this.slipMatch && this.playerProps && (this.playerProps.home_team || []).length);
    },
    hasAwayProps() {
      return !!(this.slipMatch && this.playerProps && (this.playerProps.away_team || []).length);
    },
    sortedHome() {
      return this.sortList(this.homeList, this.homeSort, "home_team");
    },
    sortedAway() {
      return this.sortList(this.awayList, this.awaySort, "away_team");
    },
    propsLocked() {
      return propsLocked(this.$store, this.slipMatch);
    },
  },
  methods: {
    sortList(list, sort, side) {
      return [...list].sort((a, b) => {
        const av = this.sortValue(a, sort.key, side);
        const bv = this.sortValue(b, sort.key, side);
        return sort.asc ? av - bv : bv - av;
      });
    },
    // the number the column shows: our price when it's on show, else the old figures
    sortValue(item, key, side) {
      const shown = this.hasPropsFor(side) && !this.propsLocked;
      if (key.startsWith("prop|")) {
        const [, market, line] = key.split("|");
        return shown ? propP(this.playerProps, side, item, market, line) || -1 : -1;
      }
      if (key === "goal_prediction") {
        if (shown) return propP(this.playerProps, side, item, "goal", "") || -1;
        return parseFloat(item.goal_prediction) || 0; // "45%" or a number
      }
      return Number(item[key]) || 0;
    },
    hasPropsFor(side) {
      return side === "home_team" ? this.hasHomeProps : this.hasAwayProps;
    },
    isOut(name, injured, suspended) {
      return injured.includes(name) || suspended.includes(name);
    },
    toggleShowMore(type) {
      if (type === "home") {
        if (this.homeVisible < this.sortedHome.length) {
          this.homeVisible = Math.min(
            this.homeVisible + 5,
            this.sortedHome.length
          );
        } else {
          this.homeVisible = 5;
        }
      } else {
        if (this.awayVisible < this.sortedAway.length) {
          this.awayVisible = Math.min(
            this.awayVisible + 5,
            this.sortedAway.length
          );
        } else {
          this.awayVisible = 5;
        }
      }
    },
    sortHome(key) {
      if (this.homeSort.key === key) {
        this.homeSort.asc = !this.homeSort.asc;
      } else {
        this.homeSort.key = key;
        this.homeSort.asc = false;
      }
    },
    sortAway(key) {
      if (this.awaySort.key === key) {
        this.awaySort.asc = !this.awaySort.asc;
      } else {
        this.awaySort.key = key;
        this.awaySort.asc = false;
      }
    },
  },
};
</script>
